export class PrimerAcceso {
    Nombre: string;
    Login: string;
    Password: string;
    PasswordRepetir: string;
    OldPassword: string;
}
